import styled from '@emotion/styled';

import { type Color as ColorName, colors } from 'ms-pages/Lantern/styles';

import type { TextColors } from './types';

export const Color = styled.span<{ color: TextColors }>(({ color }) => ({
  color: colors[color as ColorName],
}));
